import { render } from "./TrendsViewer.vue?vue&type=template&id=71b00e3a&scoped=true"
import script from "./TrendsViewer.vue?vue&type=script&lang=js"
export * from "./TrendsViewer.vue?vue&type=script&lang=js"

import "./TrendsViewer.vue?vue&type=style&index=0&id=71b00e3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b00e3a"]])

export default __exports__